module.exports = __webpack_public_path__ + "/images/cover-multi-men-share.57d377c.webp";